import { ReactChild } from "react";
import CloseIcon from "../../assets/icons/close.svg";

interface ActionDialogProps {
  heading?: string;
  children: ReactChild;
  isOpen: boolean;
  onCloseClick: () => void;
}
export const ActionDialog = ({
  heading,
  isOpen,
  onCloseClick,
  children,
}: ActionDialogProps) => {
  return isOpen ? (
    <div
      onClick={(e) => onCloseClick()}
      className="z-50 fixed flex inset-0 bg-gray-900 bg-opacity-90 transition-opacity overflow-y-auto h-full w-full cursor-pointer"
    >
      <div className="flex items-center justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:p-0 m-auto ">
        <div
          onClick={(e) => {
            e.stopPropagation();
          }}
          className="flex flex-col bg-gray-700 px-4 pt-5 pb-4 overflow-hidden shadow-xl sm:my-8 sm:align-middle max-w-md sm:max-w-xl md:max-w-2xl w-full sm:p-6 py-4 px-8 font-bold text-white transition-all rounded-md cursor-auto"
        >
          <img
            src={CloseIcon}
            alt="Close icon"
            className="ml-auto cursor-pointer h-10 h-10"
            onClick={() => onCloseClick()}
          />
          <h3 className="text-3xl text-left mt-4 mb-4 uppercase text-center">
            {heading}
          </h3>
          {children}
        </div>
      </div>
    </div>
  ) : null;
};
